import React from 'react';
import './Input.css';

/**
 * Input v2 — Professional form field
 * Props: label, error, hint, iconLeft (Lucide), iconRight (Lucide),
 *        onIconRightClick, required, as ('input'|'select'|'textarea')
 */
const Input = ({
  label,
  error,
  hint,
  iconLeft:  IconLeft,
  iconRight: IconRight,
  onIconRightClick,
  required  = false,
  className = '',
  id,
  as: Tag   = 'input',
  children,
  ...props
}) => {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '_');
  return (
    <div className={`field ${className}`}>
      {label && (
        <label htmlFor={inputId} className="field-label">
          {label}{required && <span className="required">*</span>}
        </label>
      )}
      <div className="field-control">
        {IconLeft && (
          <span className="field-icon-left"><IconLeft /></span>
        )}
        <Tag
          id={inputId}
          className={[
            Tag === 'input' || Tag === 'select' || Tag === 'textarea' ? 'field-input' : '',
            IconLeft  ? 'has-left'  : '',
            IconRight ? 'has-right' : '',
            error     ? 'field-error' : '',
          ].filter(Boolean).join(' ')}
          {...props}
        >
          {children}
        </Tag>
        {IconRight && (
          <span className="field-icon-right" onClick={onIconRightClick}>
            <IconRight />
          </span>
        )}
      </div>
      {error && <span className="field-error-msg">{error}</span>}
      {hint && !error && <span className="field-hint">{hint}</span>}
    </div>
  );
};

export default Input;
